<template>
  <div class="matrix-multiple-choice">
    <q-table :view="view" :rows="issue.rows" :columns="issue.items" :row-desc="issue.rowDesc" :widths="issue.widths">
      <template v-slot:content="{ row, col }">
        <div class="relative use-hover">
          <el-checkbox
            @click.native="mutSelectHandler(row, col)"
            :label="col.id"
            :name="row.row_id"
            :value="row.value"
            :disabled="col.disabled"
          >
            <span></span>
          </el-checkbox>
          <div class="absolute cursor-pointer inset-0 z-10" @click="mutSelectHandler(row, col)"></div>
        </div>
      </template>
    </q-table>
  </div>
</template>

<script>
import MatrixTable from '@/questions/components/MatrixTable'
import QTable from '@/questions/components/QTable'

export default {
  name: 'MatrixMultipleChoice',
  components: { QTable, MatrixTable },
  changeExpr: 'isSelectAll',
  computed: {
    isSelectAll() {
      return this.issue.rows.reduce((prev, item) => {
        return prev + '-' + item.value.join('-')
      }, '')
    }
  },
  methods: {
    mutSelectHandler(row, col) {
      let checkList = row.value
      let findIdx = checkList.findIndex(id => id === col.id)
      if (findIdx !== -1) {
        checkList.splice(findIdx, 1)
      } else {
        checkList.push(col.id)
      }
      let mutex = this.issue.mutex
      if (mutex.length) {
        row.cols.forEach(col => (col.disabled = false))
        mutex.forEach(item => {
          if (item.row_id === row.row_id) {
            let type = ''
            if (item.mutex_type === 1) {
              type = 'every'
            } else if (item.mutex_type === 2) {
              type = 'some'
            }
            this.mutexHandler(item.mutex_group1, item.mutex_group2, row, type)
          }
        })
      }

      row.selects = checkList
    },
    mutexHandler(group1, group2, row, type) {
      let list = row.value

      function isSame(id) {
        return list.includes(id)
      }

      let g1 = group1[type](isSame)
      let g2 = group2[type](isSame)
      let mutexArray = []
      if (g1) {
        mutexArray = group2
      } else if (g2) {
        mutexArray = group1
      } else {
      }

      row.cols.forEach(item => {
        if (item.disabled) return
        item.disabled = mutexArray.includes(item.id)
        if (item.disabled) {
          let idx = list.findIndex(id => item.id === id)
          if (idx > -1) {
            list.splice(idx, 1)
          }
        }
      })
    }
  },
  mounted() {
    this.$nextTick(() => {
      // TODO
      // 临时修改
      this.issue.rows.forEach(row => {
        let val = row.value.slice()
        row.value = []
        val.forEach(id => {
          let find = row.cols.find(i => i.id === id)
          if (find) {
            this.mutSelectHandler(row, find)
          }
        })
      })
    })
  }
}
</script>
